import { motion } from "framer-motion";
import { Landmark, FileText, Search, ArrowRight } from "lucide-react";

const bills = [
  { id: "HB 142", topic: "Maternal Health", status: "In Committee", color: "bg-amber-500" },
  { id: "SB 87", topic: "DBE Procurement", status: "In Committee", color: "bg-amber-500" },
  { id: "HB 301", topic: "Rural Broadband", status: "Passed House", color: "bg-primary" },
];

const HomeStatsRow = () => {
  return (
    <section className="bg-cream pt-6 md:pt-8 pb-12 md:pb-16">
      <div className="container mx-auto px-4 md:px-6 grid md:grid-cols-2 gap-5">
        {/* Legislation card */}
        <motion.a
          href="#lobbying"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="group block rounded-[var(--radius)] bg-card border border-border shadow-card p-4 sm:p-6 md:p-7 min-w-0"
        >
          <div className="flex items-start gap-3 sm:gap-4 mb-5">
            <div className="w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Landmark className="h-5 w-5 text-primary" />
            </div>
            <div className="min-w-0">
              <div className="text-primary text-xs font-semibold tracking-[0.2em] uppercase mb-1">
                Legislation Tracker
              </div>
              <div className="font-display text-xl sm:text-2xl md:text-[26px] font-bold text-foreground leading-tight">
                463 Alabama bills monitored
              </div>
            </div>
          </div>

          <ul className="space-y-2 mb-5">
            {bills.map((b) => (
              <li key={b.id} className="flex items-center gap-2 sm:gap-3 rounded-xl bg-muted/60 px-3 sm:px-4 py-2.5 sm:py-3 min-w-0">
                <FileText className="h-4 w-4 text-muted-foreground shrink-0 hidden sm:block" />
                <span className="font-display font-semibold text-sm text-foreground shrink-0">{b.id}</span>
                <span className="text-muted-foreground text-xs hidden sm:inline">·</span>
                <span className="text-sm text-foreground flex-1 min-w-0 truncate">{b.topic}</span>
                <span className="flex items-center gap-1.5 text-xs text-muted-foreground shrink-0">
                  <span className={`w-1.5 h-1.5 rounded-full ${b.color}`} />
                  <span className="truncate">{b.status}</span>
                </span>
              </li>
            ))}
          </ul>

          <span className="inline-flex items-center gap-1 text-sm text-primary font-semibold">
            View all bills
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </motion.a>

        {/* Grants card */}
        <motion.a
          href="#grants"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="group block rounded-[var(--radius)] bg-card border border-border shadow-card p-4 sm:p-6 md:p-7 min-w-0"
        >
          <div className="flex items-start gap-3 sm:gap-4 mb-5">
            <div className="w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Search className="h-5 w-5 text-primary" />
            </div>
            <div className="min-w-0">
              <div className="text-primary text-xs font-semibold tracking-[0.2em] uppercase mb-1">
                Grant Finder
              </div>
              <div className="font-display text-xl sm:text-2xl md:text-[26px] font-bold text-foreground leading-tight">
                Live federal & state grants for Alabama
              </div>
            </div>
          </div>

          <div className="flex items-end gap-4 mb-4">
            <div className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-foreground leading-none">128</div>
            <div className="text-sm text-muted-foreground pb-1">
              Matching grants<br />updated today
            </div>
          </div>

          <div className="mb-5">
            <div className="flex items-center gap-3">
              <div className="flex-1 h-2 rounded-full bg-muted overflow-hidden">
                <div className="h-full bg-primary rounded-full" style={{ width: "78%" }} />
              </div>
              <span className="text-xs font-semibold text-muted-foreground">78%</span>
            </div>
          </div>

          <div className="flex items-center gap-3 rounded-xl bg-muted/60 px-4 py-3 mb-5">
            <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-accent text-accent-foreground text-xs font-semibold">
              Open
            </span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-foreground truncate">Rural Community Development Initiative</div>
              <div className="text-xs text-muted-foreground truncate">U.S. Department of Agriculture</div>
            </div>
          </div>

          <span className="inline-flex items-center gap-1 text-sm text-primary font-semibold">
            Browse grants
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </motion.a>
      </div>
    </section>
  );
};

export default HomeStatsRow;